/* eslint-disable max-len */
var WEATHER_SUN = {
  "default": 'M7,23.59,8.41,25l-3,3L4,26.61ZM4.26,15H0v2H4.26ZM8.41,7l-3-3L4,5.39l3,3ZM17,0H15V4.26h2ZM28,5.39,26.61,4l-3,3L25,8.41ZM27.74,15v2H32V15ZM23.59,25l3,3L28,26.61l-3-3Zm1.91-9A9.5,9.5,0,1,1,16,6.53,9.51,9.51,0,0,1,25.5,16Zm-2,0a7.51,7.51,0,1,0-2.2,5.3A7.47,7.47,0,0,0,23.5,16ZM15,32h2V27.74H15Z',
  globetrotter: 'M22,16c0,3.31-2.69,6-6,6s-6-2.69-6-6,2.69-6,6-6,6,2.69,6,6ZM16,25v4.5M16,2.5v4.5M7,16H2.5M29.5,16h-4.5M6.45,25.55l3.18-3.18M25.55,6.45l-3.18,3.18M9.64,9.64l-3.18-3.18M22.36,22.36l3.18,3.18'
};

export { WEATHER_SUN };
//# sourceMappingURL=WEATHER_SUN.js.map
